import React from 'react';
import { ArrowRight, Stethoscope } from 'lucide-react';
import { motion } from 'framer-motion';
import { AnimatedCard } from './AnimatedCard';
import { Link } from 'react-router-dom';
interface ProductCardProps {
  title: string;
  description: string;
  icon: string;
  path: string;
  className?: string;
}
export const ProductCard = ({
  title,
  description,
  icon,
  path,
  className = ''
}: ProductCardProps) => {
  return <AnimatedCard>
      <div className={`bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1 ${className}`}>
        {title === 'Galenos Web' ? <motion.div className="w-16 h-16 mb-4 text-red-600" whileHover={{
        scale: 1.05
      }} transition={{
        duration: 0.2
      }}>
            <Stethoscope size={64} />
          </motion.div> : <motion.img src={icon} alt={title} className="w-16 h-16 mb-4 rounded" whileHover={{
        scale: 1.05
      }} transition={{
        duration: 0.2
      }} />}
        <h3 className="text-xl font-semibold mb-2">{title}</h3>
        <p className="text-gray-600 mb-4">{description}</p>
        <Link to={path}>
          <motion.div className="text-blue-600 inline-flex items-center" whileHover={{
          x: 5
        }} transition={{
          duration: 0.2
        }}>
            Ver más <ArrowRight className="ml-2 h-4 w-4" />
          </motion.div>
        </Link>
      </div>
    </AnimatedCard>;
};